import { backend } from '@/api/backend';

export function followSet(setId: number) {
    return backend.post(`/flashcards/sets/${setId}/follow`);
}
